var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74528 10.8891C8.72476 11.6687 7.44953 12.1318 6.06614 12.1318C2.7159 12.1318 0 9.41598 0 6.06589C0 2.71579 2.7159 0 6.06614 0C9.41637 0 12.1323 2.71579 12.1323 6.06589C12.1323 7.44946 11.669 8.72485 10.8892 9.74542L15.7659 14.6219C16.0783 14.9343 16.0783 15.4407 15.7659 15.7531L15.7532 15.7657C15.4409 16.0781 14.9344 16.0781 14.6221 15.7657L9.74528 10.8891ZM10.919 6.06589C10.919 8.74597 8.74632 10.9186 6.06614 10.9186C3.38595 10.9186 1.21323 8.74597 1.21323 6.06589C1.21323 3.38581 3.38595 1.21318 6.06614 1.21318C8.74632 1.21318 10.919 3.38581 10.919 6.06589Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b8fb6e1a.svg";
export { ForwardRef as ReactComponent };var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74528 10.8891C8.72476 11.6687 7.44953 12.1318 6.06614 12.1318C2.7159 12.1318 0 9.41598 0 6.06589C0 2.71579 2.7159 0 6.06614 0C9.41637 0 12.1323 2.71579 12.1323 6.06589C12.1323 7.44946 11.669 8.72485 10.8892 9.74542L15.7659 14.6219C16.0783 14.9343 16.0783 15.4407 15.7659 15.7531L15.7532 15.7657C15.4409 16.0781 14.9344 16.0781 14.6221 15.7657L9.74528 10.8891ZM10.919 6.06589C10.919 8.74597 8.74632 10.9186 6.06614 10.9186C3.38595 10.9186 1.21323 8.74597 1.21323 6.06589C1.21323 3.38581 3.38595 1.21318 6.06614 1.21318C8.74632 1.21318 10.919 3.38581 10.919 6.06589Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b8fb6e1a.svg";
export { ForwardRef as ReactComponent };